import {
  DailyDietPlanConnectorApollo,
  DayReplacementsConnectorApollo,
  ReplaceDayConnectorApollo,
  Loader,
  createDateObject,
  useTimestamp,
} from '@front-activerse/common-components';
import DayPlanChangeDayContainer from './components/DayPlanChangeDayContainer';
import DayReplacement from './components/DayPlanDayReplacement';
import UnauthorizedException from '../../Unauthorized/UnauthorizedException';
import { useParams } from 'react-router-dom';

// access is granted per meal, but a whole day shares the same entitlement —
// the first meal of the day answers for the day as a whole
const isDayLocked = (dailyDietPlan) => {
  const firstMeal = dailyDietPlan?.events?.find(
    (event) => event.__typename === 'UserDailyDietPlanEventMeal'
  );

  return firstMeal?.viewerAccess?.canView === false;
};

const DayReplacementPage = ({ mealPlanNavigation }) => {
  const { date } = useParams();
  const { timestamp2 } = useTimestamp();

  const renderDayReplacements = (replacements, search, replaceDay) =>
    replacements.map((replacement) => (
      <DayReplacement
        key={replacement.dietSetId}
        dayReplacement={replacement}
        search={search}
        replaceDay={replaceDay}
        date={date}
      />
    ));

  return (
    <DailyDietPlanConnectorApollo date={createDateObject(date)}>
      {({ loading, dailyDietPlan }) => {
        if (loading) {
          return <Loader />;
        }

        if (isDayLocked(dailyDietPlan)) {
          return <UnauthorizedException mealPlanNavigation={mealPlanNavigation} />;
        }

        return (
          <DayReplacementsConnectorApollo key={timestamp2 + date} date={createDateObject(date)}>
            {({ loadDayPlanDayReplacements }) => (
              <ReplaceDayConnectorApollo key={timestamp2 + date} date={createDateObject(date)}>
                {({ replaceDay }) => (
                  <DayPlanChangeDayContainer
                    key={timestamp2 + date}
                    replaceDay={replaceDay}
                    loadDayPlanDayReplacements={loadDayPlanDayReplacements}
                    renderOriginalDay={(original, search, replaceDay) =>
                      renderDayReplacements([original], search, replaceDay)
                    }
                  >
                    {(replacements, search, replaceDay) =>
                      renderDayReplacements(replacements, search, replaceDay)
                    }
                  </DayPlanChangeDayContainer>
                )}
              </ReplaceDayConnectorApollo>
            )}
          </DayReplacementsConnectorApollo>
        );
      }}
    </DailyDietPlanConnectorApollo>
  );
};

export default DayReplacementPage;
